/* Connection-health indicator. Shape and text carry the meaning as well as
   colour, so it remains readable with a colour vision deficiency. */

type Health = 'ok' | 'warn' | 'down' | 'unknown'

const COLORS: Record<Health, string> = {
  ok: 'var(--ok)',
  warn: 'var(--warn)',
  down: 'var(--danger)',
  unknown: 'var(--text-muted)',
}

const GLYPHS: Record<Health, string> = {
  ok: '●', warn: '◐', down: '○', unknown: '·',
}

export function StatusDot({
  health, label, detail,
}: {
  health: Health
  label: string
  detail?: string
}) {
  return (
    <span
      title={detail ?? label}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 'var(--sp-1)',
        fontSize: 'var(--fs-xs)', color: 'var(--text-secondary)',
      }}
    >
      <span style={{ color: COLORS[health], fontSize: 10 }} aria-hidden>
        {GLYPHS[health]}
      </span>
      <span>{label}</span>
    </span>
  )
}
